/*! global-nav */

var menuScrollPos = 0;
var menuOpen = false;
var subMenuOpen = false;
var leftNavHasItems = true;


// Top Button
//
function ShowTopButton() {
    $('.global-nav-btn-top').show();
    $('.site-nav-desktop').addClass("sticky");
}
function HideTopButton() {
    $('.global-nav-btn-top').hide();
    $('.site-nav-desktop').removeClass("sticky");
}

// Floating Controls
//
function ShowFloatingControls() {
    ShowTopButton();
    $('.global-nav-btn-open').show();
    var offset = $('div.global-nav-btn-open').outerHeight() + $('div.search.sticky').outerHeight();
    var tmp = $('div.nav-btn-open');
    if (tmp && tmp.length > 0) {
        offset = offset + $('div.nav-btn-open').outerHeight()
    }
    offset = offset - $('#maincontent').offset().top
    $('div#maincontent').height(offset + menuScrollPos);
    $('.left-nav.mobile').show();
}
function HideFloatingControls() {
    HideTopButton();
    $('div#maincontent').height(0);
    $('.left-nav.mobile').hide();
}

// ScrollCheck: activate sticky elements
//
function ScrollCheck() {
    var height = $(window).scrollTop();
    if (IsMobile()) {
        //if (height > menuScrollPos) {
        //    ShowFloatingControls();
        //} else {
        //    HideFloatingControls();
        //}
    } else {
        if (height > 100) {
            ShowTopButton();
        } else {
            HideTopButton();
        }
    }
}

// Resize Check: Hide/Show Left Navigation
//
function ResizeCheck() {
    if (!IsMobile() && leftNavHasItems) {
        $('.left-nav.desktop').show();
    } else {
        $('.left-nav.mobile').hide();
        $('.left-nav.desktop').hide();
    }
}

// Mobile Global Navigation
//
function ShowMobileMenu() {
    HideFloatingControls();
    $('.global-nav-btn-open').hide();
    $('.global-nav-btn-close').show();
    $('.global-nav-menu-mobile').slideDown();
    menuOpen = true;
}
function HideMobileMenu() {
    $('.global-nav-btn-open').show();
    $('.global-nav-btn-close').hide();
    $('.global-nav-menu-mobile').slideUp();
    CloseSubmenu();
    menuOpen = false;
}

// Mobile Subnavigation
//
function OpenSubMenu() {
    $('.nav-btn-open').hide();
    $('.global-nav-btn-close').show();
    $('.left-nav.mobile').slideDown();
    subMenuOpen = true;
}
function CloseSubmenu() {
    $('.nav-btn-open').show();
    $('.nav-btn-close').hide();
    $('.left-nav.mobile').slideUp();
    $('.global-nav-btn-open').show();
    subMenuOpen = false;
    HideEmptyLeftNav();
}
function HideEmptyLeftNav() {
    // Hide Submenu if left nav is empty
    if (!$('.left-navigation').length) {
        leftNavHasItems = false;
        $('.nav-btn-open').hide();
        $('.left-nav.mobile').hide();
    }
}

// Event Handlers
//
$(document).ready(function () {

    // ----------
    // Nav Scroll

    // Scroll Position
    menuScrollPos = $(".global-nav-btn-open").offset().top;

    // Scroll Check
    $(window).scroll(function () {
        ScrollCheck();
    });


    $(window).resize(function () {
        if (!subMenuOpen) {
            ResizeCheck();
        }
    });

    // Top Button
    $('.global-nav-btn-top').focus(function () {
        $(this).keydown(function (e) {
            if (e.keyCode == 32) {
                $(this).click();
                e.preventDefault();
            }
        });
    });
    $('.global-nav-btn-top').click(function (e) {
        $(window).scrollTop(0);
    });

    // ----------
    // Mobile Nav

    // Nav Close
    $('.global-nav-btn-close').focus(function () {
        $(this).keydown(function (e) {
            if (e.keyCode == 32) {
                $(this).click();
                e.preventDefault();
            }
        });
    });
    $('.global-nav-btn-close').click(function (e) {
        HideMobileMenu()
    });

    // Nav Open
    $('.global-nav-btn-open').focus(function () {
        $(this).keydown(function (e) {
            if (e.keyCode == 32) {
                $(this).click();
                e.preventDefault();
            }
        });
    });
    $('.global-nav-btn-open').click(function (e) {
        ShowMobileMenu();
    });

    // Subnav Open
    $('.nav-btn-open').focus(function () {
        $(this).keydown(function (e) {
            if (e.keyCode == 32) {
                $(this).click();
                e.preventDefault();
            }
        });
    });
    $('.nav-btn-open').click(function (e) {
        OpenSubMenu();
    });

    // ------------
    // Header Alert
    $('.header-alert .alert-hide-btn').focus(function () {
        $(this).keydown(function (e) {
            if (e.keyCode == 32) {
                $(this).click();
                e.preventDefault();
            }
        });
    });

    // Dismiss alert
    $('.header-alert .alert-hide-btn').click(function (e) {
        // Remove active class
        $('.header-alert.header-alert-enabled, body').removeClass('header-alert-active');
        // Set session value
        sessionStorage.setItem('alertHidden', 'true');
    });

    // Init Header Alert
    $('.header-alert').each(function (e) {
        // Check session value
        var alertHidden = sessionStorage.getItem("alertHidden");
        if (alertHidden === null || alertHidden === 'false') {
            // Check enabled
            if ($('.header-alert.header-alert-enabled').length > 0) {
                // Add Active Class
                $('.header-alert.header-alert-enabled, body').addClass('header-alert-active');
            }
        }
    });

    // -------------
    // Sticky Search
    $('.site-nav-desktop .secondary .links .search-sticky').click(function (e) {
        $('.site-nav-desktop .top .right .search').toggleClass('sticky');
        $(this).toggleClass('active', function () {
            if ($(this).hasClass('active')) {
                $('.search-text').focus();
            }
        });
    });


    //move translation item for tab index purposes
    $("#translation-link-container").detach().insertAfter('header');

    $('#translation-link-container').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('expanded');

        $(this).attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });

        $(this).find('.translation-link-list').attr('aria-hidden', function (i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });
    });

    $('#translation-link-container .translation-link').click(function (e) {
        e.preventDefault();

        var contentLocation = $('#translated-content').offset().top;
        if (!IsMobile()) {
            //account for header. 
            contentLocation = contentLocation - $('header').outerHeight();
        }
        $(window).scrollTop(contentLocation);
        $('#translation-link-container').removeClass('expanded');
    });

    //this focus keydown approach isn't going to work for re-use.... event handler gets added multiple times. 
    //split these two things apart for testing reasons. keydown isn't working when I reverse tab to the items. 
    $('#translation-link-container, .translation-link').focus(function () {
        $(this).keydown(function (e) {
            if (e.keyCode == 32) {
                $(this).click();
                e.preventDefault();
            }
        });
    });

    $('#translation-link-container, .translation-link').focusout(function () {
        $(this).off('keydown');
    });

    // -------------
    // Init left nav
    ResizeCheck();
    HideEmptyLeftNav();
});